export default __webpack_public_path__ + "static/media/date_filter.1389d853.png";